export const GET_POINTS = "admin/GET_POINTS";
export const GET_POINTS_SUCCESS = "admin/GET_POINTS_SUCCESS";
export const GET_POINTS_FAILURE = "admin/GET_POINTS_FAILURE";
export const POST_POINTS = "admin/POST_POINTS";
export const POST_POINTS_SUCCESS = "admin/POST_POINTS_SUCCESS";
export const POST_POINTS_FAILURE = "admin/POST_POINTS_FAILURE";
